;(function( window, document, $, undefined ) {

  'use strict';



	/*
		Some patterns for JS:
		- Immediately-Invoked Function Expression (IIFE)
		http://benalman.com/news/2010/11/immediately-invoked-function-expression/
		- The Module Pattern
		https://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript
		- Revealing Module Pattern
		https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
		- Locaweb Style
		http://opensource.locaweb.com.br/locawebstyle/documentacao/praticas/javascript/
		- Browser Diet
		https://browserdiet.com/
	*/

	// DOM is ready
	$(function(){

    // Variables
    var $body = $('body');
    var $menuItem = $('.menu-primary').find('.menu-item');
    var $navBlog = $('.nav-blog');
    var $zoomCards = $('.zoomCards-list');

    // Insert btn menu
    app.menu.insertBtnMainMenu();

    // Btn menu toggle
    app.menu.btnMenuToggle();

    // Sidebar Hide Widget
    app.sidebar.hideWidgetMobile();

    //- SIDEBAR
    // Add Widget Above Footer
    app.sidebar.addWidgetAboveFooter();
    // Remove Sidebar Title
    app.sidebar.removeSidebarTitle();

    // Autocomplete Search
    $('input[type="search"]').attr('autocomplete', 'off');

    // Btn Back to top
    app.buttons.btnBackToTop();

    // Copy Shared Link
    $('[data-js="clickToCopy"]').each(function(){
      var $this = $(this);
      $this.click(function(){
        app.copy.copyToClipboard($this);
        $this.siblings('.widget-social__title').addClass('-isCopied');
        setTimeout(function(){
          $this.siblings('.widget-social__title').removeClass('-isCopied');
        }, 3000);
      });
    });

    // Share Buttons
    setTimeout(function(){
      if( $('body').hasClass('job-description-page') ) {
        $('.social-media').append( $('.sidebar div[id^="share-"]') );
      };

      if( $('body').hasClass('posts-page') ) {
        $('.social-media').append( $('div[id^="share-"]').eq(0) );
      };
    }, 1000);

    // Banner Mosaic Images
    $('.banner-mosaic').find('.wpb_single_image').each(function(){
      var $this = $(this);
      var $image = $this.find('img');
      var imgSrc = $image.attr('src');
      $this.css('background-image', 'url("' + imgSrc + '")');
      $image.hide();
    });

    //app.banner.backgroundImages( $('.banner-mosaic').find('.wpb_single_image') );

    // Banner Hero
    $('.banner-mosaic, .banner-logos').wrapAll('<div class="content-hero">');
    $('.site-inner').before( $('.content-hero') );

    // Footer Wrap
    $('.footer-widgets-2, .footer-widgets-3').wrapAll('<div class="footer-widgets-group">');

    // Has Menu Openings
    app.menu.hasMenuOpenings( $menuItem );

    // Zoom Cards
    app.carousels.zoomCards( $zoomCards );

    // Fixed Menu on Scroll
    if( $navBlog.length > 0 ) {
      var menuPosition = $navBlog.offset().top;

      $(window).scroll(function () {
        var y = $(this).scrollTop();
        if( y > menuPosition ) {
          $navBlog.addClass('fixed');
        } else {
          $navBlog.removeClass('fixed');
        }
      });
    }

    // Delete Blog Category of the entry-categories
    $('.entry-categories').find('a').each(function(){
      if( $(this).text() === "Blog" ) {
        $(this).remove();
      }
    });


    // Duplicate Openings Widgets
    if( $('.openings-page').length > 0 ) {
      var widgetsContent = $('.openings-page').find('.widgets-content').clone();
      $('.content-sidebar-wrap').append( widgetsContent );
    }


    // Adjustments Min Height Content
    app.general.minHeightContent();
    $(window).resize(function(){
      app.general.minHeightContent();
    });

	});

})( window, document, jQuery );
